import type { FaireProductEntity } from "../../entity_types/product";

export const p_jnnd5v5zw9: FaireProductEntity = {
  token: "p_jnnd5v5zw9",
  type: "product",
  name: "LAS Glossy Striped Large Tote Bag",
  brandToken: "b_11782mgvt5",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/12238e792de0359b41e81bf4e41b59b8e8db05b34ec836d87cc4717f6b13223e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/23269d9f1f47f9d3da93d8972bd1460ad983f3bd342410aa22a5b6600c1bb7ee.jpeg",
    "https://cdn.faire.com/fastly/8a3c7dac9cd167a90d40366c6e28bf85c261e541217b1453f8925b3764de5ce5.jpeg",
    "https://cdn.faire.com/fastly/763eecd374c17c3d93b693b868708125b1ce2a2cb3e80174511a6f1152037201.jpeg",
    "https://cdn.faire.com/fastly/dc86233136a7ef4e0cab8dfdffa9130b114bfcdd5603d06ae4c1630047d9903a.jpeg",
    "https://cdn.faire.com/fastly/f5e7cc691c962cebe542f2eeafb8176b756aa122648cd436aa002a32d8984395.jpeg",
    "https://cdn.faire.com/fastly/7c24530910528d4a224dfb5f99b23ae8e8f73d80f5fc867b9f95735e49236371.jpeg",
    "https://cdn.faire.com/fastly/2c9d0c9c6eefd8c4663a7166591fc07bff4a7ae073234a5f5fa5024a1960b9df.jpeg",
    "https://cdn.faire.com/fastly/aeb574f3ec4d17223a76349a0d88dec6b485945d77dbeec40f7d94f462ccb891.jpeg",
    "https://cdn.faire.com/fastly/212a84290ca84a7bcdf5f36363924377fc80c5dc737101b36671d09ba53fd4da.jpeg",
    "https://cdn.faire.com/fastly/f15cd3dabfa2e0955909b259400a8182175ffe5b9700740b0ce5a57aabe272b8.jpeg",
    "https://cdn.faire.com/fastly/9a3ebd0163a46f8ff8a64b396362a519d089f66c789bf59944d299758b6d875d.jpeg",
    "https://cdn.faire.com/fastly/203c0fc81b46e535aaed3112a623dbe7212ad948ad1fef8b396c6c7d34c7ba94.jpeg",
    "https://cdn.faire.com/fastly/541351d80a1074b0cf96feede0df20e4aa8ed242318150e8998b75cf5eb807f2.jpeg",
    "https://cdn.faire.com/fastly/f0f0a87407557e5204a1c8a3f3fe18bbee353ebb9b7bdfb9f2207617c2543a39.jpeg",
    "https://cdn.faire.com/fastly/38b6ec570a484e0bfd0a09402132913706a15b987dc501b93d99d17fcc93406e.jpeg",
    "https://cdn.faire.com/fastly/97d421a7585729610e25c49527b67896a57e77e14bce1acb8fad520671d7cd97.jpeg",
    "https://cdn.faire.com/fastly/e4ec22c8e49c2ba1e572c2388c6ba0baa7b37322ab62a4dbb409c2339895bc10.jpeg",
    "https://cdn.faire.com/fastly/0ec4222ec84e9fc5654deba1fe3215eb59b42105596bd140d8bbe375b5d8d4c0.jpeg",
    "https://cdn.faire.com/fastly/aae92b1aa3869325ad6be949c60f7130636707d633be1f056675f6d4ecbbdbdc.jpeg",
    "https://cdn.faire.com/fastly/de296f7a6c2b5e64746f4458264dc0143f91b2092386508332720cdfe03a8579.jpeg",
    "https://cdn.faire.com/fastly/1154bb111a315e245cc28d2e3a9b7f3e2bbf12bc5c9ad2e197d74ac91dc81596.jpeg",
    "https://cdn.faire.com/fastly/0c9d84dc8a5379c67b3223a9d9fc14955f1d8b7e39809b68d3ee5981cbb773fb.jpeg",
    "https://cdn.faire.com/fastly/405fbc2aff5a3b5f214c314d594cd93a8a6ca6e6486f7d3dc19a62353de8e7b5.jpeg",
    "https://cdn.faire.com/fastly/105e9af95dc937ffb87adba5ab7eccc9a1b06967b6849af0d6cd59f2809a7584.jpeg",
    "https://cdn.faire.com/fastly/b6fcd7b40bcefc10e0973dbd6e55cf17bb6f5eeb7df7933530da18c3fd038d5b.jpeg",
    "https://cdn.faire.com/fastly/9d4ae971e16883af96a9a373c02137e3ac16c5b130f15de6462faaa890e09e57.jpeg",
    "https://cdn.faire.com/fastly/b14d4db2743468abd6c1c7a5eda443f330ec1f4231b7d21286bd1c55fead8cb9.jpeg",
    "https://cdn.faire.com/fastly/f704c01df96d376577f4770b7502b0c2b97c347eaa17b4aea4094f4104ec879d.jpeg",
    "https://cdn.faire.com/fastly/8f87805d8df42b28aadd17440508e6e3caaf33bb18d483c3dcfe2c965b7530df.jpeg",
    "https://cdn.faire.com/fastly/6dc9907142f85b3ef9b586e918dda03d12d29e18259d6fd26190acdd55ff1039.jpeg",
    "https://cdn.faire.com/fastly/2ec51a4b6e2f51eed0648c0467481f8632529c4ff4b5b76a9e5a61ef56acf15d.jpeg",
    "https://cdn.faire.com/fastly/b763eadf2a9ee91a7f274035bcdafd4b50ccbe3fcede101cbb3d992de58e5771.jpeg",
    "https://cdn.faire.com/fastly/3f00b2497cae48577b8469036ca995e2acee41aa291e3debbdd0d0d30e352e12.jpeg",
    "https://cdn.faire.com/fastly/5eb59af4ddbc2ce469f5a85b6de373ee615c9ccd7c9a5a78a21065624496e5f6.jpeg",
  ],
  priceDollars: 23.84,
  description:
    "✨Material: Nylon\n✨Pattern: Striped \n\n\n👏 Tag Customization Service: \nEach item comes with a care label that includes size information. We also offer custom brand labels and hang tags. If you need this service, feel free to reach out to us anytime! 💕",
  tags: [],
  msrpDollars: 47.67,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:54.765Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
